import { _ } from '../language/marker';

export const apiTranslations = [
  _('validation.accepted'),
  _('validation.active_url'),
  _('validation.after'),
  _('validation.after_or_equal'),
  _('validation.alpha'),
  _('validation.alpha_dash'),
  _('validation.alpha_num'),
  _('validation.array'),
  _('validation.before'),
  _('validation.before_or_equal'),
  _('validation.between.numeric'),
  _('validation.between.file'),
  _('validation.between.string'),
  _('validation.between.array'),
  _('validation.boolean'),
  _('validation.confirmed'),
  _('validation.date'),
  _('validation.date_equals'),
  _('validation.date_format'),
  _('validation.different'),
  _('validation.digits'),
  _('validation.digits_between'),
  _('validation.dimensions'),
  _('validation.distinct'),
  _('validation.email'),
  _('validation.exists'),
  _('validation.file'),
  _('validation.filled'),
  _('validation.gt.numeric'),
  _('validation.gt.file'),
  _('validation.gt.string'),
  _('validation.gt.array'),
  _('validation.gte.numeric'),
  _('validation.gte.file'),
  _('validation.gte.string'),
  _('validation.gte.array'),
  _('validation.image'),
  _('validation.in'),
  _('validation.in_array'),
  _('validation.integer'),
  _('validation.ip'),
  _('validation.ipv4'),
  _('validation.ipv6'),
  _('validation.json'),
  _('validation.lt.numeric'),
  _('validation.lt.file'),
  _('validation.lt.string'),
  _('validation.lt.array'),
  _('validation.lte.numeric'),
  _('validation.lte.file'),
  _('validation.lte.string'),
  _('validation.lte.array'),
  _('validation.max.numeric'),
  _('validation.max.file'),
  _('validation.max.string'),
  _('validation.max.array'),
  _('validation.mimes'),
  _('validation.mimetypes'),
  _('validation.min.numeric'),
  _('validation.min.file'),
  _('validation.min.string'),
  _('validation.min.array'),
  _('validation.not_in'),
  _('validation.not_regex'),
  _('validation.numeric'),
  _('validation.present'),
  _('validation.regex'),
  _('validation.d'),
  _('validation.d_if'),
  _('validation.d_unless'),
  _('validation.d_with'),
  _('validation.d_with_all'),
  _('validation.d_without'),
  _('validation.d_without_all'),
  _('validation.same'),
  _('validation.size.numeric'),
  _('validation.size.file'),
  _('validation.size.string'),
  _('validation.size.array'),
  _('validation.starts_with'),
  _('validation.string'),
  _('validation.timezone'),
  _('validation.unique'),
  _('validation.uploaded'),
  _('validation.url'),
  _('validation.uuid'),
];
